<template>
	<el-tabs value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('labourInfo')" id="suffixId">
			<el-row>
				<el-col :xs="24">
          <el-form :model="labourForm" :rules="rules" ref="labourForm" label-width="200px">
					  <el-card >
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskName1')" prop="subtaskId"><span>{{subtaskName}}</span></el-form-item>
								</el-col>
                <el-col :xs="24" :md="6">
									<el-form-item :label="$t('serviceStartDate1')" prop="subtaskId"><span>{{subtaskStartDate}}</span></el-form-item>
								</el-col>
                <el-col :xs="24" :md="6">
									<el-form-item :label="$t('serviceEndDate1')" prop="subtaskId"><span>{{subtaskEndDate}}</span></el-form-item>
								</el-col>
							</el-row>
            </el-card>
            <el-card>
              <el-row>
                <el-col style="margin-bottom: 10px;" :xs="24" :md="24">
                  <el-button type="primary" size="mini" @click.prevent="addRow()">{{$t('add')}}</el-button>
                  <el-button type="primary" size="mini" @click.prevent="deleteRow()">{{$t('delete')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="24">
                  <el-table :data="labourForm.labourData" style="width:100%" ref="table" tooltip-effect="dark" border @selection-change="selectRow">
                    <el-table-column type="selection" width="45" align="center" key="slt"></el-table-column>
                    <el-table-column :label="$t('sequnce')" type="index" sortable width="85" align="center" :key="Math.random()"></el-table-column>
                    <el-table-column v-if="false" key="sqs"><template slot-scope="scope"><el-input v-model="scope.row.sequnces"></el-input></template></el-table-column>
                    <el-table-column align="center" key="wd" min-width="140">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('workDate')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workDate'" :rules='rules.workDate' label-width="0px">
                          <el-date-picker v-model="scope.row.workDate" :picker-options="pickerOptions" :editable="true" clearable type="date" 
                            value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="wct" min-width="130">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('workContent')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workContent'" :rules='rules.workContent' label-width="0px">
                          <el-select v-model="scope.row.workContent" clearable >
                            <el-option v-for="item in DeliveryTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('workDescribe')" align="center" key="des" min-width="130">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workDescribe'" :rules='rules.workDescribe' label-width="0px">
                          <el-input v-model="scope.row.workDescribe" clearable />
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="wh" min-width="120">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('workHours')}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.workHours'" :rules='rules.workHours' label-width="0px">
                          <el-input v-model="scope.row.workHours" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" key="ths" min-width="140">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('travelHours')}}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.travelHours'" :rules='rules.travelHours' label-width="0px">
                          <el-input v-model="scope.row.travelHours" clearable :disabled="showLeave==1"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column :label="$t('hardwareProductLine')" align="center" key="hpl" min-width="185">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.hardwareProductLine'" :rules='rules.hardwareProductLine' label-width="0px">
                          <el-select v-model="scope.row.hardwareProductLine" clearable filterable :disabled="showLeave==1">
                            <el-option v-for="item in HardwareProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('serviceProductLine')" align="center" key="spe" min-width="165">
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.serviceProductLine'" :rules='rules.serviceProductLine' label-width="0px">
                          <el-select v-model="scope.row.serviceProductLine" clearable filterable :disabled="showLeave==1">
                            <el-option v-for="item in ServiceProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column> -->
                    <el-table-column align="center" v-if="caseFlag" key="ocn" min-width="170">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;" v-if="showRequired">* </span><span>{{caseName}}</span>      
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.ocmsCaseNumber'" :rules='rules.ocmsCaseNumber' label-width="0px">
                          <el-input v-model="scope.row.ocmsCaseNumber" clearable />
                        </el-form-item>
                      </template>
                    </el-table-column>

                    <!--新增productLine-->
                    <el-table-column align="center" v-if="productFlag" key="proli" min-width="140" >
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;">* </span><span>{{$t('ProductLine')}}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.productLine'" :rules='rules.productLine' label-width="0px">
                          <el-select v-model="scope.row.productLine" clearable>
                            <el-option v-for="item in ProductLineList" :key="item.pl2" :label="item.pl2" :value="item.pl2"></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>


                    <el-table-column :label="$t('accountName')" align="center" v-if="accountFlag" key="acne" min-width="120">
                      <template slot="header">
                        <span style="color:red;vertical-align:middle;" v-if="showAccountRequired">* </span><span>{{$t('accountName')}}</span>
                      </template>
                      <template slot-scope="scope">
                        <el-form-item :prop="'labourData.' + scope.$index + '.accountName'" :rules="[{ required: scope.row.subtaskDeliveryType=='HB_HQB_SSC'?true:false,message:'Please input value', trigger: 'change' },{ validator: '', trigger: 'change' }]" label-width="0px">
                          <el-input v-model="scope.row.accountName" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('remark')" align="center" key="rmk" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0px">
                          <el-input v-model="scope.row.remark" clearable/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
							<el-row>
								<el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" @click="submitForm('labourForm')">{{$t('save')}}</el-button>
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
							</el-row>
					  </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>


<script>
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getSubtaskList();
          this.getUserHourList();
          // this.getProductLineList('');
        },
        data () {
          var checkWorkDate = (rule, value, callback) => {
            let startDate = this.subtaskStartDate;
            let endDate = this.subtaskEndDate;
            let currDate = this.timeFormat(new Date());
            let sdate = this.sdate;
            let inputV = this.timeFormat(value);
            if(startDate > currDate || endDate < sdate){
              return callback(new Error("Not in subtask time range"));
            }else if(startDate < sdate){
              if(endDate <= currDate && inputV > endDate){
                return callback(new Error("Subtask end date cannot be exceeded"));
              }
            }else{
              if(inputV < startDate){
                return callback(new Error("Subtask start date cannot be exceeded"));
              }else if(inputV > endDate){
                return callback(new Error("Subtask end date cannot be exceeded"));
              }
            }
            callback();
          };
          var checkHours = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }
            if(this.showLeave == 1){
              if(value < 0.01 || value > 8){
                return callback(new Error('Please enter 0.01--8.00'));
              }
            }else{
              if(value < 0.01 || value > 24){
                return callback(new Error('Please enter 0.01--24.00'));
              }
            }
            let whour = this.labourForm.labourData[index].workHours;
            let thour = this.labourForm.labourData[index].travelHours;
            if(whour != null && thour != null){
              let sum = parseFloat(whour) + parseFloat(thour);
              if(sum > 24){
                return callback(new Error('The sum of WorkHours and TravelHours cannot exceed 24'));
              }
            }
            let wDate = this.labourForm.labourData[index].workDate;
            wDate = this.timeFormat(wDate);
            if(wDate != null && wDate != ""){
              let uhour = 0;
              this.userHours.forEach(item => {
                let iDate = this.timeFormat(item.workDate);
                if (iDate == wDate) {
                  uhour = item.workHours;
                }
              });
              let sum = parseFloat(whour) + parseFloat(uhour);
              if(sum > 24){
                return callback(new Error('Working hours per day shall not exceed 24 hours'));
              }else{
                let hdata = this.labourForm.labourData;
                if(hdata.length > 1){
                  let vhour = 0;
                  hdata.forEach(item => {
                    let iDate = this.timeFormat(item.workDate);
                    if (iDate == wDate) {
                      vhour = parseFloat(vhour) + parseFloat(item.workHours);
                    }
                  });
                  let sum = parseFloat(vhour) + parseFloat(uhour);
                  if(sum > 24){
                    return callback(new Error('Working hours per day shall not exceed 24 hours'));
                  }
                }
              }
            }
            callback();
          };
          var checkTravelHours = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }else if(value < 0 || value > 24){
              return callback(new Error('Please enter 0--24.00'));
            }
            let whour = this.labourForm.labourData[index].workHours;
            let thour = this.labourForm.labourData[index].travelHours;
            if(whour != null && thour != null){
              let sum = parseFloat(whour) + parseFloat(thour);
              if(sum > 24){
                return callback(new Error('The sum of WorkHours and TravelHours cannot exceed 24'));
              }
            }
            callback();
          };
          var checkDescribe = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let content = this.labourForm.labourData[index].workContent;
            if(content == 'Others'){
              if(value == null || value == ''){
                return callback(new Error('Please enter describe'));
              }
            }
            callback();
          };
          var changeOcmsCaseNo = (rule, value, callback) => {
            if(this.showRequired){
              if(value == null || value == ""){
                return callback(new Error("Please input value"));
              }
            }
            callback();
          };
          return {
            pickerOptions: {disabledDate: time => {return this.selectWorkDate(time)}},
            labourForm: {
              projectId:null,
              taskId:null,
              subtaskId:null,
              labourData:[],
            },
            num:0,
            showLeave:0,
            sdate:null,
            subtaskName:null,
            subtaskStartDate:null,
            subtaskEndDate:null,
            caseFlag:false,
            productFlag:false,
            caseName:null,
            showRequired:false,
            accountFlag:true,
            showAccountRequired:false,
            multipleSelection:[],
            SubTList:[],
            userHours:[],
            DeliveryTypeList:[],
            ProductLineList:[],
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            rules: {
              subtaskId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              workDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkWorkDate, trigger: 'change' }
              ],
              workHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkHours, trigger: 'blur' }
              ],
              workContent: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              workDescribe: [
                { validator: checkDescribe, trigger: 'blur' }
              ],
              travelHours: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkTravelHours, trigger: 'blur' }
              ],
              ocmsCaseNumber: [
                { validator: changeOcmsCaseNo, trigger: 'blur' }
              ],
              productLine: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              accountFlag: [
                 { validator: changeOcmsCaseNo, trigger: 'blur' }
              ],
            },
            accountName:null,
          }
        },
        methods:{
          getUserHourList(){
            let url =`${this.$store.state.islhurl}labourHour/getHour`;
            let pm = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.userHours = res.labours;
              }
            )
          },
          getSubtaskList(){
            let url =`${this.$store.state.islhurl}subtask/getSubtaskToHour`;
            let pm = {
              subtaskNumber : this.$route.params.subtaskNumber,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {
                this.sdate = res.sdate;
                this.labourForm.projectId = res.subtask.projectId;
                this.labourForm.taskId = res.subtask.taskId;
                this.labourForm.subtaskId = res.subtask.subtaskNumber;
                this.subtaskName = res.subtask.subtaskName;
                this.subtaskStartDate = this.timeFormat(res.subtask.serviceStartDate);
                this.subtaskEndDate = this.timeFormat(res.subtask.serviceEndDate);
                this.accountName = res.subtask.customerName?res.subtask.customerName:null;
                this.subtaskDeliveryType = res.subtask.subtaskDeliveryType?res.subtask.subtaskDeliveryType:null;
                this.selectSubtaskName(res.subtask);
                this.getProductLineList(res.subtask)
              }
            )
          },
          getProductLineList(subtask){
            let url = `${this.$store.state.islhurl}productline/getSelectData`
            let pm = {
              subtaskRemark:subtask.subtaskRemark,
              taskId:subtask.taskId,
            }
            this._post(url,pm).then(
              res =>{
                this.ProductLineList = res.data;
              }
            )
          },
          selectSubtaskName(subtask){
            if(subtask.subtaskDeliveryType == "PersonalLeave"){
              this.showLeave = 1;
            }else{
              this.showLeave = 0;
            }
            if(subtask.subtaskRemark == "MSN"){
              this.caseFlag = true;
              this.showRequired = false;
              this.caseName = 'IPMS Project Number';
            }else if(subtask.subtaskRemark == "MSP"){
              this.caseFlag = true;
              this.showRequired = false;
              this.caseName = 'PMS Project Number';
            }else if(subtask.subtaskDeliveryType == "Maintenance"){
              this.caseFlag = true;
              this.showRequired = true;
              this.caseName = 'OCMS Case Number';
            }else if(subtask.subtaskRemark == "CDMA"){
              this.caseFlag = true;
              this.showRequired = false;
              this.caseName = 'Service Contract Number';
            }
            else if(subtask.subtaskDeliveryType == "Case"){
              this.caseFlag = true;
              this.accountFlag = true;
              this.showRequired = true;
              this.showAccountRequired = false;
              this.caseName = 'OCMS Case Number';
            }else if(subtask.subtaskDeliveryType == "HB_HQB_SSC"){
               this.caseFlag = true;
              this.accountFlag = true;
              this.showRequired = true;
              this.showAccountRequired = true;
              this.caseName = 'OCMS Case Number';
            }else if(subtask.subtaskDeliveryType == "NECCase"){
              this.caseFlag = true;
              this.showRequired = true;
              this.caseName = 'NEC Case Number';
            }else if(subtask.subtaskRemark == "CDROD"){
              this.caseFlag = true;
              this.showRequired = false;
              this.caseName = 'OCMS Case Number';
            }else{
              this.caseFlag = false;
              this.accountFlag = false;
              this.showRequired = false;
            }
            //判断是否显示productLine
            if(subtask.subtaskRemark == "MSS" || subtask.subtaskRemark == "WDC" || subtask.subtaskRemark == "BC" || subtask.subtaskRemark == "PID" || subtask.subtaskRemark == "PI" ||  subtask.subtaskDeliveryType == "HB_HQB_SSC"){
              this.productFlag = true;
            }
            
            //通过任务类型查询交付类型
            if(subtask.subtaskDeliveryType == 'Value' || subtask.subtaskDeliveryType == 'Training Service'){
              this.DeliveryTypeList = [{sysDesc:subtask.deliveryEngineerCity,sysValue:subtask.deliveryEngineerCity}];
            }else if(subtask.subtaskRemark == 'MST'){
              this.DeliveryTypeList = [{sysDesc:subtask.deliveryAddress,sysValue:subtask.deliveryAddress}];
            }else{
              let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
              let pm = {
                sysKey: 'SubtaskDeliveryType',
                remark: subtask.subtaskDeliveryType,
              }
              this._post(url,pm).then(
                res => {
                  this.DeliveryTypeList = res.data;
                }
              )
            }
          },
          selectWorkDate(time){
            if(this.showLeave == 1){
              return false;
            }else{
              return (time > new Date() || time.getTime() < new Date(this.sdate)  - 8.64e7);
            }
          },
          submitForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.addInfo();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          addInfo(){
            if(this.labourForm.labourData.length == 0){
              this.$message.warning('Please add the labour hour first！');
              return;
            }
            let params = {
              labourHours:this.labourForm.labourData,
              projectId:this.labourForm.projectId,
              taskId:this.labourForm.taskId,
              subtaskId:this.labourForm.subtaskId,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}labourHour/addInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.$router.push({path:'/labour/list'})
                  this.$Message.success('Save successful' )
                }else{
                  this.$message({
                    type:'error',
                    showClose:true,
                    duration:10000,
                    message:res
                  });
                }
              }
            )
          },
          addRow(){
            let addlist = {};
            let length = this.labourForm.labourData.length;
            if(length > 0){
              let labourData = this.labourForm.labourData[length-1];
              addlist = {
                sequnces:labourData.sequnces+1,workDate:labourData.workDate,workHours:labourData.workHours,workContent:labourData.workContent,
                workDescribe:labourData.workDescribe,travelHours:labourData.travelHours,hardwareProductLine:labourData.hardwareProductLine,
                serviceProductLine:labourData.serviceProductLine,ocmsCaseNumber:labourData.ocmsCaseNumber,accountName:labourData.accountName,
                remark:labourData.remark,productLine:labourData.productLine,subtaskDeliveryType:labourData.subtaskDeliveryType,
              };
            }else{
              let workContent = null;
              if(this.showLeave == 1){
                workContent = "Personal Leave";
              }
              addlist = {
                sequnces:this.num++,
                workDate:new Date(),
                workHours:null,
                workContent:workContent,
                workDescribe:null,
                travelHours:0,
                hardwareProductLine:null,
                serviceProductLine:null,
                ocmsCaseNumber:null,
                accountName:this.accountName,
                subtaskDeliveryType:this.subtaskDeliveryType,
                productLine:null,
                remark:null,
              };
            }
            this.labourForm.labourData.push(addlist);
          },
          selectRow(val){
            this.multipleSelection = val;
          },
          deleteRow() {
            if(this.multipleSelection.length == 0){
              this.$message.warning('Please choose the data first！');
              return;
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
              let val = this.multipleSelection;
              val.forEach((val, index) => {
                this.labourForm.labourData.forEach((v, i) => {
                  if (val.sequnces === v.sequnces) {
                    // i 为选中的索引
                    this.labourForm.labourData.splice(i, 1);
                  }
                });
              });
            }
          },
          returnList(){
            this.$router.push({path:'/labour/list'})
          },
          getBeforeFirst(time) {
            const dateTime = new Date(time);
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth();
            return year + "-" +this.addZero(month) + "-01";
          },
          timeFormat (time) {
            if(time == null || time == ""){
              return null;
            }
            const dateTime = new Date(time);
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth() + 1;
            const date = dateTime.getDate();
            // const hour = dateTime.getHours()
            // const minute = dateTime.getMinutes()
            // const second = dateTime.getSeconds()
            // return year + "-" +this.addZero(month) + "-" + this.addZero(date) + " " + this.addZero(hour) + ":" + this.addZero(minute) + ":" + this.addZero(second);
            return year + "-" +this.addZero(month) + "-" + this.addZero(date);
          },
          addZero (v) {
            return v < 10 ? '0' + v : v;
          }
        },
    }	
</script>


// WEBPACK FOOTER //
// src/view/labour/labourAdd.vue